import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ProjectCard } from "@/components/ProjectCard";
import { Reveal } from "@/components/Reveal";
import { ProjectCardSkeleton } from "@/components/Skeletons";
import { Skeleton } from "@/components/ui/skeleton";
import { Seo } from "@/components/Seo";

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const categories = ["All", ...Array.from(new Set(projects.map((p) => p.category)))];
  const filtered = filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-6 py-10" data-testid="projects-page">
      <Seo title="Projects" description="In-depth case studies covering frontend architecture, performance, and design systems." path="/projects" />
      <Reveal>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Work</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-light tracking-tighter mt-3 max-w-3xl leading-[1.05]">
          Case studies with real <span className="italic font-semibold">depth</span>.
        </h1>
      </Reveal>

      <div className="flex flex-wrap gap-2 mt-10">
        {loading
          ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-9 w-24 rounded-full" />)
          : categories.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 rounded-full text-sm transition-colors ${
                  filter === c ? "bg-primary text-primary-foreground" : "glass text-muted-foreground hover:text-foreground"
                }`}
              >
                {c}
              </button>
            ))}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => <ProjectCardSkeleton key={i} />)
          : filtered.map((p, i) => <ProjectCard key={p.id} project={p} index={i} />)}
      </div>
      {!loading && filtered.length === 0 && (
        <p className="text-muted-foreground mt-10">No projects yet.</p>
      )}
    </div>
  );
}
